import API from './base';

const version = 'v1';

export default {

  getDefaultActivityForBooking(payload) {
    return API.get(`${version}/activity-for-booking`, {
      params: payload,
    });
  },
  getActivities(payload) {
    return API.get(`${version}/activities`, {
      params: payload,
    });
  },
  getActivityDetails(payload) {
    return API.get(`${version}/activity/${payload}`);
  },
  confirmActivity(id, payload) {
    return API.post(`${version}/activity/${id}/confirm`, payload);
  },
};
